import { useState } from "react";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaModalHeader } from "../../../shared/wrappers/FixaModal/FixaModalHeader";
import { FixaModalFooter } from "../../../shared/wrappers/FixaModal/FixaModalFooter";
import { FixaInputField } from "../../../shared/wrappers/FixaInputField/FixaInputField";
import FixaButton from "../../../shared/wrappers/FixaButton/FixaButton";
import { useCreatePermission } from "../../repositories/permissions.repository";
import { FixaModalBody } from "../../../shared/wrappers/FixaModal/FixaModalBody";

type Props = {
  isVisible: boolean;
  setIsOpen: (open: boolean) => void;
};

const AddNewPermissionModal = ({ isVisible, setIsOpen }: Props) => {
  const [permissionCode, setPermissionCode] = useState("");
  const [permissionDescription, setPermissionDescription] = useState("");
  const createPermissionMutation = useCreatePermission();

  const handleAddClick = async () => {
    try {
      await createPermissionMutation.mutateAsync({
        code: permissionCode,
        description: permissionDescription,
      });
      setPermissionCode("");
      setPermissionDescription("");
      setIsOpen(false);
    } catch {
      // Keep modal open on error so user can retry
    }
  };

  const handleClose = () => {
    setPermissionCode("");
    setPermissionDescription("");
    setIsOpen(false);
  };
  return (
    <FixaModal visible={isVisible} handleCloseBtn={handleClose}>
      <FixaSheets
        labelledById="feature-flags-add-new-permission-modal-header"
        alignment="right"
        preserveAlignment={false}
        size="small"
        fullSize
        header={
          <FixaModalHeader
            id="feature-flags-add-new-permission-modal-header"
            title={"Add new permission"}
            floating={false}
          />
        }
        footer={
          <FixaModalFooter>
            <FixaButton
              onClick={handleAddClick}
              disabled={!permissionCode || !permissionDescription}
            >
              Add
            </FixaButton>
          </FixaModalFooter>
        }
      >
        <FixaModalBody>
          <FixaInputField
            id={"permissionCodeInput"}
            type={"text"}
            value={permissionCode}
            onChange={(e) => setPermissionCode(e.target.value)}
            label={"Permission code"}
          ></FixaInputField>
          <FixaInputField
            id={"permissionDescriptionInput"}
            type={"text"}
            value={permissionDescription}
            onChange={(e) => setPermissionDescription(e.target.value)}
            label={"Permission description"}
          ></FixaInputField>
        </FixaModalBody>
      </FixaSheets>
    </FixaModal>
  );
};

export default AddNewPermissionModal;
